// extracted by mini-css-extract-plugin
export default {"courseHeader":"course-header_courseHeader__M2Ue6","header":"course-header_header__rf6tR"};